module.exports = __webpack_public_path__ + "media/assets/images/blog/customerize_7239-e5f8eada9f8477c98b99c10d4bbfc2eb.jpg";